import { fetchPopularAirports } from 'actions/FlightActions'
import TextInputOnly from 'components/Common/Form/Input/TextInputOnly'
import VerticalSpacer from 'components/Common/Spacing/VerticalSpacer'
import LineSearchIcon from 'LuxKit/Icons/line/LineSearchIcon'
import { useAppDispatch } from 'hooks/reduxHooks'
import noop from 'lib/function/noop'
import type { ChangeEventHandler } from 'react'
import { useCallback, useEffect, useState } from 'react'
import { useIntl } from 'react-intl'
import OfferAirportOptionsList from './OfferAirportOptionsList'

interface Props {
  onSelectAirport?: (airport: App.AirportLocation) => void
}

function OfferAirportOptions(props: Props) {
  const {
    onSelectAirport = noop,
  } = props
  const intl = useIntl()
  const [searchPhrase, setSearchPhrase] = useState('')

  const dispatch = useAppDispatch()

  useEffect(() => {
    dispatch(fetchPopularAirports())
  }, [dispatch])

  const onChangeInputText = useCallback<ChangeEventHandler<HTMLInputElement>>((event) => {
    setSearchPhrase(event.target.value)
  }, [])

  return <VerticalSpacer gap={20}>
    <TextInputOnly
      placeholder={intl.formatMessage({
        id: 'MSBSsIGoyeyYxNxDTSCn',
        defaultMessage: 'Search by city or airport',
        description: 'Placeholder text for airport search input on offer page',
      })}
      onChange={onChangeInputText}
      endIcon={<LineSearchIcon />}
    />
    <OfferAirportOptionsList searchPhrase={searchPhrase} onSelectAirport={onSelectAirport} />
  </VerticalSpacer>
}

export default OfferAirportOptions
